import React, { useState } from "react";
import ContainerContent from "components/Container/ContainerContent";
import {
  LEASING_REQUEST_PURPOSE_OPTIONS,
  LEASING_REQUEST_STATUS_OPTIONS,
  RESERVE_OPTIONS,
} from "./constrant/leasing.ct.options";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import _ from "lodash";
import Select from "react-select";
import classNames from "classnames";
import FootageSearch from "./footage/leasing.f.search";
import FootageFilter from "./footage/leasing.f.filter";
import FootageRequestTableMain from "./footage/leasing.f.tableRequestMain";
import { Auth, Storage } from "aws-amplify";
import {
  checkParseJSONString,
  getLastItem,
  getStatments,
  prePareQueryRequest,
  tryParseJSON,
} from "./utils/leasing.u";
import { useEffect } from "react";
import { useCallback } from "react";
import LoadingPage from "../Loading/LoadingPage";
import FootageReserve from "./footage/leasing.f.reserve";
import FootageCompleteAllRequest from "./footage/leasing.f.completeAllRequest";
import FootageExportRequest from "./footage/leasing.f.exportRequest";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import { LIMIT_OPTIONS } from "./constrant/leasing.ct.options";
import FootagePagination from "./footage/leasing.f.pagination";
import DataEmpty from "../DataEmpty";
import { useHistory } from "react-router-dom";
import { SubmitLocalStorageSearch } from "../../function";
import ImportTransferLoan from "./footage/leasing.f.importTransferLoan";
import API from "./api/api.main";
import axios from "axios";

let source = axios.CancelToken.source();

function LeasingRequest() {
  const history = useHistory();

  const isTransfer = history?.location?.pathname?.includes(
    "/leasingTransferLoan"
  );

  const getDefaultQuery = () => {
    const today = getCurrentLocalDateTime();
    const objQuery = {
      Limit: LIMIT_OPTIONS[0],
      request_id: "",
      ScanIndexForward: false,
      status: isTransfer
        ? LEASING_REQUEST_STATUS_OPTIONS[13]
        : LEASING_REQUEST_STATUS_OPTIONS[1],
      category: LEASING_REQUEST_PURPOSE_OPTIONS[0],
      min: "",
      max: "",
      reserveBy: RESERVE_OPTIONS[2],
    };
    return objQuery;
  };

  const [loading, setLoading] = useState(true);
  const [searchBy, setSearchBy] = useState("phone_number");
  const [formQuery, setFormQuery] = useState(getDefaultQuery());
  const [formLastItem, setFormLastItem] = useState(null);
  const [countRecord, setCountRecord] = useState({ รับคำร้อง: 0 });
  const [currentCountRecord, setCurrentCountRecord] = useState("รับคำร้อง");
  const [loadingCountRecord, setLoadingCountRecord] = useState(true);
  const [leasings, setLeasings] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageType, setPageType] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [prevLeasings, setPrevLeasings] = useState([]);

  const searchBar = useSelector((state) => state.searchBar);
  const { user } = useSelector((state) => state.initializeApp);

  useEffect(() => {
    fetchLeasingRequest(getDefaultQuery());
    setCurrentCountRecord(new Date().getTime());

    // if (source) {
    //   return () => {
    //     source?.cancel("Operation canceled by the user.");
    //   };
    // }
  }, [isTransfer]);

  useEffect(() => {
    if (pageType === "NEXT") {
      setPrevLeasings(_.cloneDeep(leasings));
    }
  }, [pageIndex]);

  const fetchLeasingRequest = async (
    query,
    firstLoading = true,
    isSort = false,
    paSearchBar = searchBar,
    paSearchBy = searchBy
  ) => {
    try {
      setLoading(firstLoading);

      if (isTransfer) {
        delete query.reserveBy;
      }

      const data = await API.get("MoneyHubAdmin", "/leasing/request", {
        queryStringParameters: {
          ...prePareQueryRequest(_.cloneDeep(query), paSearchBy, paSearchBar),
          reserveByAdminName: user.username,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
        cancelToken: source?.token,
      });

      let leasing_requests = data?.leasing_requests;

      if (isSort) {
        leasing_requests = leasing_requests?.reverse();
      }

      const promiseLeasings = await Promise.all(
        leasing_requests.map(async (request) => {
          return {
            ...request,
            ori_statementUris: request?.statementUris
              ? tryParseJSON(request?.statementUris)
              : [],
            ori_pdpaUri: request?.pdpaUri,
            ori_creditUri: request?.creditUri,
            ori_fileBuro: request?.fileBuro,

            pdpaUri: !request?.pdpaUri
              ? ""
              : await Storage.get(request?.pdpaUri),
            creditUri: !request?.creditUri
              ? ""
              : await Storage.get(request?.creditUri),
            fileBuro: !request?.fileBuro
              ? ""
              : await Storage.get(request?.fileBuro),
            statementUris: !request.statementUris
              ? ""
              : await getStatments(tryParseJSON(request.statementUris)),
            contractUri: !request.contractUri
              ? ""
              : await Storage.get(request.contractUri),
          };
        })
      );
      setLeasings(promiseLeasings);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const onSearchBy = (value) => {
    setSearchBy(value);
  };

  const onChangeFormQuery = (e) => {
    const { name, value } = e.target;
    setFormQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeFormDate = (name) => (date, dateString) => {
    setFormQuery((prev) => {
      return {
        ...prev,
        [name]: date,
      };
    });
  };

  const onChangeSelect = (typeSelect) => (e) => {
    setFormQuery((prev) => {
      return {
        ...prev,
        [typeSelect]: e,
      };
    });
  };

  const onClickPrevPageEmpty = async () => {
    setLeasings(_.cloneDeep(prevLeasings));
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
  };

  return (
    <div className="bg-gray-100 px-6 pt-20 h-screen">
      <div className="w-full mb-2 lg:flex items-center">
        <FootageSearch
          primaryKey={"request_id"}
          searchBy={searchBy}
          onSearchBy={onSearchBy}
        />
      </div>

      <div className="flex items-center">
        {!isTransfer && (
          <FootageCompleteAllRequest
            isTransfer={isTransfer}
            refetch={fetchLeasingRequest}
            formQuery={formQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
        )}
        {isTransfer && <ImportTransferLoan />}
        <FootageExportRequest
          countRecord={countRecord}
          currentCountRecord={currentCountRecord}
          setCurrentCountRecord={setCurrentCountRecord}
          isTransfer={isTransfer}
          setLoadingCountRecord={setLoadingCountRecord}
          setCountRecord={setCountRecord}
          refetch={fetchLeasingRequest}
          formQuery={formQuery}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          searchBy={searchBy}
        />
        {!isTransfer && (
          <FootageReserve
            refetch={fetchLeasingRequest}
            getDefaultQuery={getDefaultQuery}
            formQuery={formQuery}
            setFormQuery={setFormQuery}
            onChangeSelect={onChangeSelect}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
        )}
      </div>
      <FootageFilter
        setCurrentCountRecord={setCurrentCountRecord}
        isTransfer={isTransfer}
        onChangeFormDate={onChangeFormDate}
        getDefaultQuery={getDefaultQuery}
        formQuery={formQuery}
        setFormQuery={setFormQuery}
        onChangeSelect={onChangeSelect}
        onChangeFormQuery={onChangeFormQuery}
        refetch={fetchLeasingRequest}
      />
      <div className="mt-6 ">
        {!leasings.length && !loading ? (
          pageType === "NEXT" ? (
            <ContainerContent>
              <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
                สิ้นสุดรายการ
              </div>
              <div className="w-full mt-2 flex items-center">
                {" "}
                <button
                  className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                  onClick={onClickPrevPageEmpty}
                >
                  ย้อนกลับ
                </button>
              </div>
            </ContainerContent>
          ) : (
            <ContainerContent>
              <DataEmpty />
            </ContainerContent>
          )
        ) : (
          <React.Fragment>
            <div className="flex justify-between items-center mb-1">
              <div className="flex space-x-1">
                {loadingCountRecord ? (
                  <div className="w-12 mr-2">
                    <Skeleton />
                  </div>
                ) : (
                  <div>{countRecord[currentCountRecord]}</div>
                )}
                <div>Records</div>
              </div>
              <FootagePagination
                primaryKey="request_id"
                searchBy={searchBy}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                setPageType={setPageType}
                pageType={pageType}
                countRecords={countRecord}
                leasings={leasings}
                formQuery={formQuery}
                setFormQuery={setFormQuery}
                refetch={fetchLeasingRequest}
                onChangeSelect={onChangeSelect}
              />
            </div>
            <FootageRequestTableMain
              isTransfer={isTransfer}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              refetch={fetchLeasingRequest}
              loading={loading}
              leasings={leasings}
              setLeasings={setLeasings}
              query={formQuery}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default LeasingRequest;
